import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { getElementHeight, getVisibleWidth } from '@utils/browser';

function CompanyOpeningsHeader({ mainRef, bannerRef, children, id }) {
  const instanceRef = useRef();

  useEffect(() => {
    function handleScroll() {
      const main = mainRef.current;
      const banner = bannerRef.current;
      const width = getVisibleWidth();
      if (width < 600) {
        return;
      }

      if (instanceRef.current && window.pageYOffset > getElementHeight(banner)) {
        instanceRef.current.classList.add('sticky');
        if (main && main.style) {
          main.style.marginTop = '62px';
        }
      } else {
        instanceRef.current.classList.remove('sticky');
        if (main && main.style) {
          main.style.marginTop = '0px';
        }
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [bannerRef, mainRef]);

  return (
    <Wrapper id={id} ref={instanceRef}>
      {children}
    </Wrapper>
  );
}

export default observer(CompanyOpeningsHeader);

const Wrapper = styled.div`
  color: ${(p) => p.theme.primaryColor};
  background-color: #ffffff;
  min-height: 62px;
  padding: 10px;
  width: 100%;
  display: flex;
  z-index: 10;
  align-items: center;

  > div {
    margin: 0 auto;
    width: 100%;
    max-width: 980px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 1080px) {
      padding: 0 20px;
    }
  }

  @media (max-width: 600px) {
    button {
      display: none;
    }
  }

  &.sticky {
    @media (min-width: 600px) {
      position: fixed;
      width: 100%;
      top: 0px;
      left: 0;
    }
  }
  box-sizing: border-box;
`;
